import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../shared/components/Button';
import Card from '../../../shared/components/Card';

const AuthLanding = () => {
  const navigate = useNavigate();

  const handleAdminChoice = () => {
    console.log('🔘 Admin button clicked - navigating to /admin/signin');
    try {
      navigate('/admin/signin');
      console.log('✅ Navigation to /admin/signin initiated successfully');
    } catch (error) {
      console.error('❌ Navigation error for /admin/signin:', error);
    }
  };

  const handleMemberChoice = () => {
    console.log('🔘 Member button clicked - navigating to /member/signin');
    try {
      navigate('/member/signin');
      console.log('✅ Navigation to /member/signin initiated successfully');
    } catch (error) {
      console.error('❌ Navigation error for /member/signin:', error);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-neutral-100 to-neutral-50">
      {/* Header */}
      <div className="text-center py-8">
        <div className="mb-6">
          <h1 className="text-4xl font-bold tracking-tight mb-2"><span className="text-neutral-900">Esu</span><span className="text-primary-500">Sol</span></h1>
          <p className="text-lg text-neutral-600">Digital Savings Groups Made Simple</p>
        </div>
        <p className="text-neutral-600 max-w-md mx-auto">
          Choose how you'd like to sign in to access your savings group
        </p>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="max-w-md w-full space-y-8">
          {/* Admin Option */}
          <Card>
            <div className="p-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-primary-500 rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg className="w-8 h-8 text-neutral-50" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 006 0zm-7 9a7 7 0 1114 0H3a1 1 0 01-1-1V8a1 1 0 011-1h8a1 1 0 011 1v1a1 1 0 01-1 1h6a7 7 0 01-7-7z" clipRule="evenodd" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-neutral-900 mb-4">I am an Admin</h2>
                <p className="text-neutral-600 mb-6">
                  Manage groups, invite members, and oversee contributions
                </p>
                <Button
                  onClick={handleAdminChoice}
                  variant="primary"
                  size="lg"
                  className="w-full"
                >
                  Continue as Admin →
                </Button>
              </div>
            </div>
          </Card>

          {/* Member Option */}
          <Card>
            <div className="p-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-success-500 rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zm-7 9a7 7 0 1114 0H3a1 1 0 01-1-1V8a1 1 0 011-1h8a1 1 0 011 1v1a1 1 0 01-1 1h6a7 7 0 01-7-7z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-neutral-900 mb-4">I am a Member</h2>
                <p className="text-neutral-600 mb-6">
                  View your contributions, track payments, and manage your membership
                </p>
                <Button
                  onClick={handleMemberChoice}
                  variant="primary"
                  size="lg"
                  className="w-full"
                >
                  Continue as Member →
                </Button>
              </div>
            </div>
          </Card>

          {/* Help Section */}
          <div className="text-center pt-8">
            <p className="text-sm text-neutral-500">
              Need help?{' '}
              <button
                onClick={() => navigate('/faq')}
                className="text-primary-600 hover:text-primary-500"
              >
                Contact Support
              </button>
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="text-center py-8">
        <p className="text-sm text-neutral-500">
          © 2026 EsuSol. All rights reserved.
        </p>
        {/* Static legal pages served from public/ (open in a new tab so the app
            session is untouched). */}
        <p className="mt-2 text-xs text-neutral-400">
          <a href="/privacy.html" target="_blank" rel="noopener noreferrer" className="underline hover:text-neutral-600">
            Privacy Policy
          </a>
          <span className="mx-2">·</span>
          <a href="/terms.html" target="_blank" rel="noopener noreferrer" className="underline hover:text-neutral-600">
            Terms
          </a>
        </p>
      </div>
    </div>
  );
};

export default AuthLanding;
